import type { Book, BookLibrary, ReadingStatus } from "../models/types";
import { loadSortOption } from "../services/local-storage";

/** Possible views in the app */
export type View = "list" | "detail" | "add" | "notFound";

/** Sort option for the book list */
export type SortOption = "dateRead" | "series" | "title";

/** Confirmation modal options */
export interface ModalOptions {
  title: string;
  message: string;
  confirmLabel: string;
  confirmColor: string;
  onConfirm: () => void;
}

/** Application state */
export interface AppState {
  library: BookLibrary;
  view: View;
  /** Currently selected/editing book id */
  selectedBookId: string | null;
  /** Filter by reading status (null = all) */
  filterStatus: ReadingStatus | null;
  /** Search query */
  searchQuery: string;
  /** Active sort option */
  sortOption: SortOption;
  /** Loading state */
  loading: boolean;
  /** Toast message */
  toast: string | null;
  /** Whether utilities menu is open */
  showUtilities: boolean;
  /** Confirmation modal */
  modal: ModalOptions | null;
  /** Form snapshot for dirty detection */
  formSnapshot: string | null;
  /** Saved scroll position for list view */
  savedScrollTop: number;
}

export function createInitialState(library: BookLibrary): AppState {
  return {
    library,
    view: "list",
    selectedBookId: null,
    filterStatus: null,
    searchQuery: "",
    sortOption: loadSortOption(),
    loading: false,
    toast: null,
    showUtilities: false,
    modal: null,
    formSnapshot: null,
    savedScrollTop: 0,
  };
}

/** Get the currently selected book */
export function getSelectedBook(state: AppState): Book | undefined {
  if (!state.selectedBookId) return undefined;
  return state.library.books.find((b) => b.id === state.selectedBookId);
}
